// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1_LYZ","cls2":"ConfirmationModal-cls2_FgF ConfirmationModal-cls1_LYZ","border":"ConfirmationModal-border_AzM"};